import { postData } from '../plugins/ApiCalls'

export function getSetupIntent(data) {
  return postData('stripe/setup-intent/' + data.session, data)
}

export function getCouponCode(data) {
  return postData('stripe/coupon-code', data)
}
